import React from 'react';
import ListaAdmin from '../shared/ListaAdmin';

function ListaFrutos() {
  return <ListaAdmin tipo="fruto" />;
}

export default ListaFrutos;
